import * as React from 'react';
import { ProgressIndicator, } from '@here/hds-progress-indicator';
// eslint-disable-next-line no-new
new ProgressIndicator();
const HDSProgressIndicator = React.forwardRef((props, ref) => {
    const { className, indicatorType, ...rest } = props;
    return (React.createElement("hds-progress-indicator", { ref: ref, ...(indicatorType && { 'indicator-type': indicatorType }), ...(className && { class: className }), ...rest }));
});
HDSProgressIndicator.defaultProps = {
    color: 'accent',
    variant: 'indeterminate',
    size: 'large',
    progress: 0,
    indicatorType: 'linear',
};
export default HDSProgressIndicator;
//# sourceMappingURL=HDSProgressIndicator.js.map